<template>
	<div>
		<v-text-field
			v-model="template.name"
			type="text"
			class="ma-1 mt-4"
			label="テンプレート名"
			:rules="[rules.required]"
			outlined
			dense
		/>
		<v-sheet class="pa-2">
			<h5 class="text-h6 font-weight-bold">デフォルト項目</h5>
			<v-card-text class="text-body-1 pa-0 mt-2"> 件名（必須） </v-card-text>
			<v-card-text class="text-body-1 pa-0 mt-2"> 日付（必須） </v-card-text>
			<v-card-text class="text-body-1 pa-0 mt-2"> 開始時間（必須） </v-card-text>
			<v-card-text class="text-body-1 pa-0 mt-2"> 終了時間（必須） </v-card-text>
			<v-card-text class="text-body-1 pa-0 mt-2"> 場所 </v-card-text>
			<v-card-text class="text-body-1 pa-0 mt-2"> 内容 </v-card-text>
		</v-sheet>
		<v-row class="mx-0 my-4 px-2" justify="space-between">
			<h5 class="text-h6 font-weight-bold">追加項目</h5>
			<v-btn color="secondary" @click="addMetaKey">
				<v-icon class="mr-2">mdi-plus</v-icon>
				項目追加</v-btn
			>
		</v-row>
		<div v-if="filteredMetaKeys.length">
			<MetaKeyForm
				v-for="(metaKey, i) in filteredMetaKeys"
				:metaKeyData.sync="filteredMetaKeys[i]"
				:metaTypes="metaTypes"
				:polymorphicOptions="polymorphicOptions"
				:optionTypes="optionTypes"
				:key="i"
				@remove-meta-key="removeMetaKey(i)"
				@delete-meta-key="deleteMetaKey($event)"
			/>
		</div>
		<template v-else>
			<v-card class="pa-4" elevation="0">
				<v-card-text class="text-bg-grey">
					日報テンプレートに合わせて追加で項目を設定できます。
					<br />
					項目名、入力の形式（型）、必須項目かどうかの設定が可能です。
				</v-card-text>
			</v-card>
		</template>
	</div>
</template>

<script>
import rules from "../../../helper/rules"
import MetaKeyForm from "./DailyReportMetaKeyForm.vue"
export default {
	props: {
		templateData: {
			type: Object,
			required: true,
			default: {
				name: {
					type: String,
					required: true,
					default: null,
				},
				daily_report_meta_keys_attributes: {
					type: Array,
					required: true,
					default: [],
				},
			},
		},
		metaTypes: {
			type: Array,
			required: true,
		},
		optionTypes: {
			type: Array,
			required: true,
		},
		polymorphicOptions: {
			type: Array,
			required: true,
		},
	},
	components: {
		MetaKeyForm,
	},
	data() {
		return {
			rules: rules,
		}
	},
	methods: {
		addMetaKey() {
			const metaKey = {
				name: null,
				meta_type: null,
				required_flag: false,
				option_type: "not_required",
				association_name: null,
				daily_report_meta_options_attributes: [],
			}
			this.template.daily_report_meta_keys_attributes.push(metaKey)
		},
		removeMetaKey(i) {
			const child = this.filteredMetaKeys[i]
			const index = this.template.daily_report_meta_keys_attributes.indexOf(child)
			this.template.daily_report_meta_keys_attributes.splice(index, 1)
		},
		deleteMetaKey(id) {
			const child = this.filteredMetaKeys.find((m) => m.id == id)
			const index = this.template.daily_report_meta_keys_attributes.indexOf(child)
			this.template.daily_report_meta_keys_attributes.splice(index, 1)
		},
	},
	computed: {
		template: {
			get() {
				return this.templateData
			},
			set(newValue) {
				return this.$emit("update:template", newValue)
			},
		},
		filteredMetaKeys() {
			return this.template.daily_report_meta_keys_attributes.filter(
				(m) => m.status != "deleted" && m.status != "archived"
			)
		},
	},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
.meta-key-form {
	&:not(:first-child) {
		border-top: 1px solid whitesmoke;
	}
}
</style>